import { useCallback, useEffect, useState } from "react";
import Header from "../../Components/Header";
import SidePanel from "../../Components/SidePanel";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Loader";
import Search from "../../Components/Search";
import CourseTable from "./ContactTable";
import CreateCourse from "./CreateContact";
import CourseFilter from "./ContactFilter";

import {
  COURSES_TOTAL_COUNTS,
  COURSE_LIST_DELETE,
  COURSE_LIST_DELETE_RESET_FORM,
} from "../../Actions/courseAction";
import { listContact } from "../../Actions/contactAction";
import {
  contactFilterjson,
  PartnerContactJson,
} from "../../Models/contactModel";

export default function Contact() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const [FormOpener, setFormOpener] = useState(false);
  const [EditFormOpener, setEditFormOpener] = useState(false);
  const [Alert, setAlert] = useState(false);
  const [CourseID, setCourseID] = useState("");
  const [Courses_Search_Name, setCourses_Search_Name] = useState("");
  const [TableFilter, setTableFilter] = useState(contactFilterjson);
  const [PartnerForm, setPartnerForm] = useState({ ...PartnerContactJson });
  const { loading, contactRecs, error } = useSelector(
    (state) => state.listContactReducer
  );

  const { Course_Delete_Success, Course_Delete_Error } = useSelector(
    (state) => state.COURSE_DELETE_REDUCER
  );

  const dispatch = useDispatch();

  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };

  /* handle Searching according to University name start  */
  const handleSearch_data = (e) => {
    if (e.target.value === "" || e.target.value === null) {
      contactRecss_Get_Req({ ...TableFilter, searchtxt: "" });
    } else {
      setCourses_Search_Name(e.target.value);
    }
  };

  const handleUniversityWebDetails_Search_data = async () => {
    contactRecss_Get_Req({ ...TableFilter, searchtxt: Courses_Search_Name });
  };

  const handleUniversityWebDetailsSearching = (e) => {
    e.preventDefault();
    handleUniversityWebDetails_Search_data();
  };

  const handleKey = (e) => {
    if (e.key === "Enter") {
      handleUniversityWebDetails_Search_data();
    }
  };
  /* handle Searching according to University name End  */

  const handleFormClose = useCallback(() => {
    setFormOpener(!FormOpener);
  }, [FormOpener]);

  const handleEditorForm = useCallback(() => {
    setEditFormOpener(!EditFormOpener);
  }, [EditFormOpener]);

  const handleEditCourseData = (Id) => {
    setCourseID(Id);
    handleEditorForm();
  };

  const contactRecss_Get_Req = useCallback(
    (filter_data = TableFilter) => {
      setTableFilter(filter_data);
      dispatch(listContact(filter_data));
      dispatch(COURSES_TOTAL_COUNTS(filter_data));
    },
    [dispatch, TableFilter]
  );

  const handleClearFilter = () => {
    contactRecss_Get_Req(contactFilterjson);
  };

  let debounce;
  const handleSliderFilter = (e) => {
    if (debounce) {
      clearTimeout(debounce);
    }

    debounce = setTimeout(() => {
      contactRecss_Get_Req({
        ...TableFilter,
        FeesFrom: e[0],
        FeesTill: e[1],
        PageNo: 1,
      });
    }, 1000);
  };

  const handleFilter = (e) => {
    contactRecss_Get_Req({
      ...TableFilter,
      [e.target.name]: e.target.value,
      PageNo: 1,
    });
  };

  const handleDeleteCourse = (ID) => {
    dispatch(COURSE_LIST_DELETE(ID));
  };

  useEffect(() => {
    contactRecss_Get_Req();
  }, [Course_Delete_Success, contactRecss_Get_Req]);

  useEffect(() => {
    if (Course_Delete_Success) {
      setAlert(Course_Delete_Success);
    }
    if (Course_Delete_Error) {
      setAlert(Course_Delete_Error);
    }

    if (Course_Delete_Error || Course_Delete_Success) {
      setTimeout(() => {
        setAlert(false);
        dispatch(COURSE_LIST_DELETE_RESET_FORM());
      }, 2000);
    }
  }, [Course_Delete_Success, Course_Delete_Error, dispatch]);

  return (
    <>
      <Header Page={"Contacts"} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      {/*<!-- Pushable content along with off-canvas opener. -->*/}
      <div className="bs-offset-main bs-canvas-anim">
        <div className="content-body">
          {/*<!--Body-content-->*/}
          <div className="container-fluid">
            <div className="heading-title">
              <div className="row">
                <div className="col-md-12">
                  <div style={{marginBottom:"10px"}} className="home-table-search">
                    {/* Courses Details Search  */}
                    <Search
                      handleSearch={handleSearch_data}
                      handleSearching={handleUniversityWebDetailsSearching}
                      handleKey={handleKey}
                      SearchData={Courses_Search_Name}
                      placeholder={"Search Contacts"}
                    />

                    {/* <div className="right-click Create-btn">
                      <a
                        href="#"
                        className="btn create-contact"
                        onClick={() => handleFormClose()}
                      >
                        Send To Affiliate Partner
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {Alert && (
              <div className="side_drawer">
                <div className={Course_Delete_Success ? "Alert2" : "Alert3"}>
                  <span onClick={() => setAlert(false)} className="close">
                    &times;
                  </span>
                  <p>{Alert}</p>
                </div>
              </div>
            )}
            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Contacts..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/*<!-- /filter-in-mob-view -->*/}
                  <CourseFilter
                    TableFilter={TableFilter}
                    handleFilter={handleFilter}
                    handleClearFilter={handleClearFilter}
                    handleSliderFilter={handleSliderFilter}
                  />
                </div>
                {/*<!-- Courses Details Table -->*/}

                {loading ? (
                  <div>
                    <Loader />
                  </div>
                ) : error ? (
                  <div>
                    <img
                      className="No_data"
                      src="./assets/img/NoRecord.png"
                      alt="data_notfound"
                    />
                  </div>
                ) : (
                  <CourseTable
                    handleEditCourseData={handleEditCourseData}
                    handleDeleteCourse={handleDeleteCourse}
                    contactRecss_Get_Req={contactRecss_Get_Req}
                    contactRecs={contactRecs}
                    TableFilter={TableFilter}
                    setTableFilter={setTableFilter}
                    LOADING={loading}
                    setFormOpener={setFormOpener}
                    setPartnerForm={setPartnerForm}
                    PartnerForm={PartnerForm}
                  />
                )}
              </div>
            </div>
            <CreateCourse
              CourseID={CourseID}
              contactRecss_Get_Req={contactRecss_Get_Req}
              FormOpener={FormOpener}
              setFormOpener={setFormOpener}
              handleFormClose={handleFormClose}
              PartnerForm={PartnerForm}
              setPartnerForm={setPartnerForm}
            />
            {/*<!--/overlay-Create-contact-->*/}
          </div>
        </div>
      </div>
    </>
  );
}
